module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1016.a87795e4.png";